import { AppleApplication } from '@era/locations-sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export type ConfiguredApplication = AppleApplication & { deviceId: string };

export function selectDeviceConfiguredApplicationsId(application: ConfiguredApplication) {
  return `${application.deviceId}-${application.bundleIdentifier}`;
}

export const adapter: EntityAdapter<ConfiguredApplication> = createEntityAdapter<ConfiguredApplication>({
  selectId: selectDeviceConfiguredApplicationsId,
});

export type DeviceConfiguredApplicationsState = EntityState<ConfiguredApplication>;

export const initialState: DeviceConfiguredApplicationsState = adapter.getInitialState();
